// Constants
import {
  MIN_YEARS_IN_HOME,
  MAX_YEARS_IN_HOME,
  MIN_RENTABLE_NIGHTS,
  MAX_RENTABLE_NIGHTS,
} from '../../../../../constants/buyerSettings'
import { INPUT_NAMES } from '../../../../../constants/display'

const mustBeInRange = (min, max) => `Must be ${min}-${max}`
const mustBeGreaterThan = bound => `Must be greater than ${bound}`

const validator = values => {
  const errors = {}
  const {
    currentMonthlyCost,
    maxBudget,
    downPayment,
    yearsInHome,
    rentableNights,
  } = values

  if (!currentMonthlyCost || !maxBudget || !downPayment || !yearsInHome) {
    errors.blank = 'You must complete all fields'
  }

  if (currentMonthlyCost && currentMonthlyCost <= 0) {
    errors[INPUT_NAMES.CURRENT_MONTHLY_COST] = mustBeGreaterThan(0)
  }

  if (maxBudget && maxBudget <= 0) {
    errors[INPUT_NAMES.MAX_BUDGET] = mustBeGreaterThan(0)
  }

  if (downPayment && downPayment <= 0) {
    errors[INPUT_NAMES.DOWN_PAYMENT] = mustBeGreaterThan(0)
  }

  if (
    yearsInHome &&
    (yearsInHome < MIN_YEARS_IN_HOME || yearsInHome > MAX_YEARS_IN_HOME)
  ) {
    errors[INPUT_NAMES.YEARS_IN_HOME] = mustBeInRange(
      MIN_YEARS_IN_HOME,
      MAX_YEARS_IN_HOME
    )
  }

  if (
    rentableNights &&
    (rentableNights < MIN_RENTABLE_NIGHTS ||
      rentableNights > MAX_RENTABLE_NIGHTS)
  ) {
    errors[INPUT_NAMES.RENTABLE_NIGHTS] = mustBeInRange(
      MIN_RENTABLE_NIGHTS,
      MAX_RENTABLE_NIGHTS
    )
  }

  return errors
}

export default validator
